import {Dispatch} from 'redux';

import {METHODS} from '../../constants';
import {get, makeUrl, post} from '../../utils/fetcher';

import {GroupTree} from '../../types/Category';
import {ReportDomainForm} from '../../types/Lookup';

// Each object in tree can have either subgroups or category
// Categories are the keys that have arrays as values. Groups are keys with objects as value
// To exclude subgroups, take keys that have arrays as values
function extractCategoriesFromGroupTree(rootNode: GroupTree): string[] {
  const result: string[] = [];
  const queue: GroupTree[] = [];
  queue.push(rootNode);
  while (queue.length !== 0) {
    const node = queue.shift();
    if (!node) break;

    for (const key of Object.keys(node)) {
      const value = node[key];
      if (Array.isArray(value)) {
        result.push(key);
      } else if (typeof value === 'object') {
        queue.push(value);
      }
    }
  }

  return result;
}

export const getCategoriesList = (
  // eslint-disable-next-line no-unused-vars
  callback: (result: string[]) => void,
) => {
  const url = makeUrl(METHODS.GET_GROUPS_TREE);
  return (dispatch: Dispatch) => get(url, dispatch)
    .then((response) => {
      if (response && response.data) {
        const categories = extractCategoriesFromGroupTree(response.data);
        callback(categories.sort((cat1, cat2) => cat1.localeCompare(cat2)));
      }
    });
};

export const sendDomainReport = (
  form: ReportDomainForm,
) => {
  const url = makeUrl(METHODS.REPORT_DOMAIN);
  return (dispatch: Dispatch) => post(url, form, dispatch);
};
